export default function EmptyRumblesListIcon() {
  return (
    <svg
      width='260'
      height='218'
      viewBox='0 0 260 218'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M292 188.735H-28v.16h320v-.16ZM259.936 199.036h-21.198v.16h21.198v-.16ZM183.981 200.773h-5.564v.16h5.564v-.16ZM238.097 193.093h-12.283v.16h12.283v-.16ZM33.218 194.168H5.574v.16h27.644v-.16ZM42.97 194.168h-4.054v.16h4.053v-.16ZM116.094 196.871H56.142v.16h59.952v-.16ZM123.689 160.192H.105a3.658 3.658 0 0 1-3.653-3.653V-17.177a3.658 3.658 0 0 1 3.653-3.654H123.69a3.657 3.657 0 0 1 3.652 3.654v173.716a3.657 3.657 0 0 1-3.652 3.653ZM.105-20.67a3.497 3.497 0 0 0-3.493 3.493V156.54a3.497 3.497 0 0 0 3.493 3.493H123.69a3.497 3.497 0 0 0 3.492-3.493V-17.177a3.497 3.497 0 0 0-3.492-3.494L.105-20.67ZM262.118 160.192H138.535a3.657 3.657 0 0 1-3.652-3.653V-17.177a3.657 3.657 0 0 1 3.652-3.654h123.583a3.657 3.657 0 0 1 3.653 3.654v173.716a3.656 3.656 0 0 1-3.653 3.653ZM138.535-20.67a3.497 3.497 0 0 0-3.492 3.493V156.54a3.497 3.497 0 0 0 3.492 3.493h123.583a3.497 3.497 0 0 0 3.493-3.493V-17.177a3.497 3.497 0 0 0-3.493-3.494l-123.583.001Z'
        fill='#EBEBEB'
      />
      <path d='M177.184.708H16.173v92.243h161.011V.708Z' fill='#DFDFDF' />
      <path d='M179.579.708H17.292v92.243h162.287V.708Z' fill='#F0F0F0' />
      <path d='M176.226 89.186V4.474H20.643v84.712h155.583Z' fill='#FAFAFA' />
      <path
        d='M39.74 89.185 59.415 4.474H85.21L65.533 89.185H39.74ZM69.708 89.185 89.385 4.474h11.648L81.357 89.185H69.708ZM115.93 89.185l19.676-84.711h19.896l-19.677 84.711H115.93Z'
        fill='#fff'
      />
      <path d='M176.226 89.186V4.474h-.426v84.712h.426Z' fill='#DFDFDF' />
      <path d='M103.272.708H93.6v92.243h9.672V.708Z' fill='#F0F0F0' />
      <path
        d='M93.599 89.185V4.474h-.426v84.711h.426ZM98.603.708h-.336v92.243h.336V.708ZM119.093 129.033h-13.652v59.702h13.652v-59.702Z'
        fill='#DFDFDF'
      />
      <path
        d='M113.181 188.735h5.911v-9.907h-12.11l6.199 9.907Z'
        fill='#F5F5F5'
      />
      <path d='M13.186 129.033H-.464v59.702h13.65v-59.702Z' fill='#DFDFDF' />
      <path d='M119.094 129.033H8.027v56.292h111.067v-56.292Z' fill='#F5F5F5' />
      <path
        d='M13.939 188.735H8.027v-9.907h12.11l-6.198 9.907Z'
        fill='#F5F5F5'
      />
      <path
        d='M114.507 133.769H12.613v20.763h101.894v-20.763Z'
        fill='#F0F0F0'
      />
      <path
        d='M63.561 150.215a6.07 6.07 0 0 1-6.064-6.064 6.07 6.07 0 0 1 6.064-6.064 6.07 6.07 0 0 1 6.064 6.064 6.071 6.071 0 0 1-6.064 6.064Zm0-11.488a5.43 5.43 0 0 0-5.424 5.424 5.43 5.43 0 0 0 5.424 5.424 5.43 5.43 0 0 0 5.424-5.424 5.432 5.432 0 0 0-5.424-5.424Z'
        fill='#fff'
      />
      <path
        d='M114.507 159.547H12.613v20.763h101.894v-20.763Z'
        fill='#F0F0F0'
      />
      <path
        d='M63.56 175.993a6.072 6.072 0 0 1-6.064-6.064 6.071 6.071 0 0 1 6.065-6.064 6.07 6.07 0 0 1 6.064 6.064 6.071 6.071 0 0 1-6.064 6.064Zm0-11.488a5.43 5.43 0 0 0-5.424 5.424 5.43 5.43 0 0 0 5.425 5.424 5.43 5.43 0 0 0 5.424-5.424 5.43 5.43 0 0 0-5.424-5.424Z'
        fill='#fff'
      />
      <path
        d='M132.922 188.733h45.361v-44.232h-45.361v44.232Z'
        fill='#DFDFDF'
      />
      <path
        d='M237.902 144.502h-59.619v44.232h59.619v-44.232Z'
        fill='#F0F0F0'
      />
      <path
        opacity='.7'
        d='M132.922 148.071h104.979v-7.337H132.922v7.337Z'
        fill='#DFDFDF'
      />
      <path d='M130.634 144.501h47.649v-4.234h-47.649v4.234Z' fill='#DFDFDF' />
      <path d='M240.19 140.267h-61.907v4.235h61.907v-4.235Z' fill='#F0F0F0' />
      <path
        d='M257.809 179.504c3.696-7.98.223-17.444-7.756-21.14-7.979-3.696-17.443-.224-21.139 7.756-3.696 7.979-.224 17.443 7.755 21.139 7.979 3.696 17.444.224 21.14-7.755Z'
        fill='#DFDFDF'
      />
      <path
        opacity='.7'
        d='M239.74 161.075c-1.343.249-2.53-.082-2.652-.739-.121-.656.869-1.39 2.211-1.639 1.343-.249 2.53.082 2.651.739.122.657-.868 1.391-2.21 1.639ZM233.603 164.945c-.954.977-2.116 1.389-2.593.923-.478-.467-.092-1.637.863-2.614.954-.977 2.115-1.389 2.593-.923.478.467.091 1.638-.863 2.614ZM238.986 166.876c-1.088.826-2.38.954-2.886.287-.506-.668-.035-1.878 1.053-2.703 1.088-.826 2.38-.954 2.886-.286.506.667.035 1.877-1.053 2.702Z'
        fill='#DFDFDF'
      />
      <path d='M247.498 11.668h-45.867v70.323h45.867V11.668Z' fill='#DFDFDF' />
      <path d='M251.383 11.668h-48.686v70.323h48.686V11.668Z' fill='#F5F5F5' />
      <path d='M248.279 78.887V14.773h-42.477v64.114h42.477Z' fill='#fff' />
      <path
        d='M240.803 48.63V45.03h-27.524v3.598h27.524ZM240.803 39.558V35.96h-27.524v3.598h27.524ZM240.802 30.488v-3.599h-27.524v3.599h27.524ZM240.803 57.7v-3.598h-27.524V57.7h27.524ZM240.802 66.77v-3.597h-27.524v3.598h27.524ZM132 217.639c68.533 0 124.089-3.244 124.089-7.247 0-4.002-55.556-7.246-124.089-7.246-68.532 0-124.089 3.244-124.089 7.246 0 4.003 55.557 7.247 124.089 7.247Z'
        fill='#F5F5F5'
      />
      <path
        d='m107.521 204.825 4.852-1.336-1.805-11.592-4.852 1.337 1.805 11.591ZM66.245 204.95h5.032l1.254-11.654h-5.033l-1.253 11.654Z'
        fill='#FFC3BD'
      />
      <path
        d='M71.692 204.368h-6.136a.438.438 0 0 0-.428.343l-.994 4.474a.74.74 0 0 0 .736.895c1.974-.034 3.415-.15 5.901-.15 1.53 0 6.143.159 8.255.159 2.066 0 2.388-2.089 1.523-2.278-3.878-.848-6.8-2.018-8.04-3.134a1.221 1.221 0 0 0-.817-.309ZM112.185 202.936l-5.299 1.46a.44.44 0 0 0-.322.446l.23 4.577c.024.474.48.804.936.67 1.902-.559 4.634-1.432 7.036-2.094 2.809-.775 5.276-1.29 8.571-2.198 1.991-.549 1.989-2.714 1.105-2.667-4.024.216-7.148.981-10.985-.138-.417-.122-.854-.171-1.272-.056Z'
        fill='#0D1333'
      />
      <path
        d='M93.78 47.386c.195.237.483.576.739.867l.8.912a53.63 53.63 0 0 0 1.67 1.781c1.147 1.154 2.31 2.282 3.528 3.306 2.404 2.057 5.034 3.814 7.564 4.603.317.112.622.169.933.25l.454.077c.272.038-.002.022-.018.047-.078.029.056.037.258-.036a4.67 4.67 0 0 0 .748-.32c.567-.295 1.193-.713 1.812-1.173.628-.453 1.26-.959 1.885-1.49 2.501-2.126 4.99-4.569 7.402-6.974l3.036 2.25c-1.82 3.165-3.832 6.104-6.286 8.921-1.25 1.403-2.548 2.77-4.357 4.04-.461.318-.963.63-1.562.918a7.417 7.417 0 0 1-2.257.679 6.458 6.458 0 0 1-1.326.01l-.849-.077c-.548-.085-1.108-.163-1.633-.295a17.917 17.917 0 0 1-3.038-.968 25.85 25.85 0 0 1-2.749-1.321c-1.754-.96-3.336-2.088-4.836-3.267a46.611 46.611 0 0 1-4.196-3.797 61.177 61.177 0 0 1-1.914-2.051c-.31-.352-.623-.701-.921-1.069-.31-.375-.58-.711-.925-1.163l6.039-4.66Z'
        fill='#FFC3BD'
      />
      <path
        d='m95.537 62.763 1.96 1.967 9.01-7.22-3.224-2.502-7.746 7.755Z'
        fill='#0D1333'
      />
      <path
        d='M84.98 49.554C84.605 54.35 95.41 64.14 95.41 64.14l9.548-8.282s-4.022-4.258-8.538-8.542c-3.106-2.946-11.037-2.951-11.44 2.238Z'
        fill='#0D1333'
      />
      <path
        opacity='.5'
        d='M84.98 49.554C84.605 54.35 95.41 64.14 95.41 64.14l9.548-8.282s-4.022-4.258-8.538-8.542c-3.106-2.946-11.037-2.951-11.44 2.238Z'
        fill='#316CF4'
      />
      <path
        opacity='.2'
        d='M98.716 61.274a16.458 16.458 0 0 0-.352-1.337c-1.242-3.943-4.077-7.514-8.519-7.917-2.003-.18-2.592 1.228-2.438 3.296 3.085 4.37 8 8.825 8 8.825l.806-.698L97.5 64.73l1.542-1.236a15.004 15.004 0 0 0-.326-2.22Z'
        fill='#0D1333'
      />
      <path
        d='m121.161 50.957 1.438-4.223 5.654 1.45s-1.797 2.14-3.83 3.663l-3.262-.89ZM124.841 44.914l4.681 1.628-1.269 1.641-5.654-1.45 2.242-1.819Z'
        fill='#FFC3BD'
      />
      <path
        opacity='.2'
        d='m110.567 191.9.931 5.975-4.854 1.337-.931-5.974 4.854-1.338ZM67.497 193.299h5.035l-.648 6.008h-5.035l.648-6.008Z'
        fill='#0D1333'
      />
      <path
        d='M64.527 47.232c1.552 5.561 2.544 11.225 3.198 16.555.476 3.9.763 7.62.94 10.996.418 7.91.244 13.942.479 15.985 3.935-.272 18.765-1.304 26.85-1.87 3.658-28.627-3.325-43.376-3.325-43.376s-2.973-.593-6.428-.795a30.66 30.66 0 0 0-1.387-.055c-3.041-.064-7.999.392-11.417.795a52.11 52.11 0 0 0-2.151.305c-3.594.584-6.759 1.46-6.759 1.46Z'
        fill='#0D1333'
      />
      <path
        opacity='.5'
        d='M64.527 47.232c1.552 5.561 2.544 11.225 3.198 16.555.476 3.9.763 7.62.94 10.996.418 7.91.244 13.942.479 15.985 3.935-.272 18.765-1.304 26.85-1.87 3.658-28.627-3.325-43.376-3.325-43.376s-2.973-.593-6.428-.795a30.66 30.66 0 0 0-1.387-.055c-3.041-.064-7.999.392-11.417.795a52.11 52.11 0 0 0-2.151.305c-3.594.584-6.759 1.46-6.759 1.46Z'
        fill='#316CF4'
      />
      <path
        d='m89.973 62.034-5.862.393a.37.37 0 0 1-.38-.299l-.049-.277c-.045-.256-.359-.39-.548-.233l-3.156 2.6c-.169.14-.12.42.095.534l3.995 2.122c.24.127.5-.045.454-.3l-.05-.278a.284.284 0 0 1 .266-.342l5.862-.392a.285.285 0 0 0 .266-.342l-.513-2.888a.37.37 0 0 0-.38-.298ZM79.513 60.583l5.862-.393a.37.37 0 0 1 .38.3l.05.277c.045.255.358.39.548.233l3.155-2.601c.169-.14.12-.42-.095-.533l-3.995-2.122c-.239-.128-.499.044-.453.3l.049.278a.285.285 0 0 1-.266.341l-5.862.393a.285.285 0 0 0-.266.341l.513 2.889a.371.371 0 0 0 .38.297Z'
        fill='#fff'
      />
      <path
        d='M73.436 45.466c3.418-.403 8.378-.858 11.418-.794.467.007.934.026 1.389.052.051 0 .109.006.16.012.813 1.684 1.868 6.693-1.876 7.211-5.082.704-10.828-3.684-13.24-6.174a46.973 46.973 0 0 1 2.15-.307Z'
        fill='#0D1333'
      />
      <path
        opacity='.2'
        d='M71.308 54.475c.014 4.5-1.227 8.303-3.325 11.636-.074-.766-.163-1.54-.258-2.322-.358-2.93-.82-5.963-1.433-9.028l5.016-.286Z'
        fill='#0D1333'
      />
      <path
        d='M73.673 32.535c.976 3.622 2.165 10.302-.234 12.932 2.02 1.808 4.925 3.264 9.045 2.887 3.155-.29 3.16-2.51 2.37-3.684-4.164-.692-4.27-3.738-3.756-6.642l-7.425-5.493Z'
        fill='#FFC3BD'
      />
      <path
        opacity='.2'
        d='m76.7 34.777 4.395 3.249c-.124.687-.21 1.382-.21 2.05-1.58-.117-3.85-1.684-4.13-3.31-.14-.812-.161-1.6-.054-1.99Z'
        fill='#0D1333'
      />
      <path
        d='M92.148 13.394c1.858 3.916-5.457 13.42-11.426 12.4-2.905-.495-6.78-1.53-9.994-2.46-2.903-.841-3.965-4.67-1.209-5.154 9.344-1.647 19.542-11.288 22.629-4.786Z'
        fill='#0D1333'
      />
      <path
        d='M72.851 27.038c.653 4.951.783 7.883 3.473 10.26 4.046 3.576 10.025.87 10.865-4.177.757-4.543-.437-11.878-5.443-13.517-4.933-1.615-9.548 2.482-8.895 7.434Z'
        fill='#FFC3BD'
      />
      <path
        d='M82.488 33.37h-.002c-2.053.131-3.083-1.217-3.126-1.274a.128.128 0 0 1 .205-.154c.01.013.995 1.294 2.904 1.172a.129.129 0 0 1 .02.257ZM76.33 29.28c1.878-4.086 2.28-8.263-1.146-9.54-3.427-1.278-6.313.434-7.268 3.014-.956 2.579 5.68 12.48 8.415 6.526Z'
        fill='#0D1333'
      />
      <path
        d='M72.436 21.49c3.442 2.467 15.246 2.614 13.58-1.815-1.247-3.317-9.444-3.214-13.58 1.815Z'
        fill='#0D1333'
      />
      <path
        d='M70.987 32.677c.785 1.094 2.003 1.723 3.098 1.885 1.646.243 2.262-1.28 1.63-2.725-.569-1.301-2.11-2.995-3.68-2.577-1.546.412-1.946 2.166-1.048 3.417Z'
        fill='#FFC3BD'
      />
      <path
        d='m113.008 196.253-8.217 2.261s-10.288-32.434-12.816-50.246c-.67-4.723-1.705-11.365-3.284-18.443-1.994-8.918-4.494-18.562-6.541-26.114-2.16-7.953-3.805-13.583-3.805-13.583l17.653-1.23s9.552 41.66 10.564 56.986c1.056 15.937 6.446 50.369 6.446 50.369Z'
        fill='#316CF4'
      />
      <path
        opacity='.3'
        d='m113.008 196.253-8.217 2.261s-10.288-32.434-12.816-50.246c-.67-4.723-1.705-11.365-3.284-18.443-1.994-8.918-4.494-18.562-6.541-26.114-2.16-7.953-3.805-13.583-3.805-13.583l17.653-1.23s9.552 41.66 10.564 56.986c1.056 15.937 6.446 50.369 6.446 50.369Z'
        fill='#FAFAFA'
      />
      <path
        opacity='.2'
        d='M88.69 129.825c-1.993-8.918-4.493-18.562-6.54-26.114l1.832-3.945c4.379 5.203 5.556 21.31 4.709 30.059Z'
        fill='#0D1333'
      />
      <path
        d='M86.474 89.562s-1.905 43.086-4.03 57.678c-2.326 15.98-8.235 50.903-8.235 50.903h-9.217s-.155-33.113 2.733-48.591c3.288-17.63 1.422-58.78 1.422-58.78l17.327-1.21Z'
        fill='#316CF4'
      />
      <path
        opacity='.3'
        d='M86.474 89.562s-1.905 43.086-4.03 57.678c-2.326 15.98-8.235 50.903-8.235 50.903h-9.217s-.155-33.113 2.733-48.591c3.288-17.63 1.422-58.78 1.422-58.78l17.327-1.21Z'
        fill='#FAFAFA'
      />
      <path
        d='M75.312 198.342H64.458V195.1l12.133-.211-1.279 3.453ZM113.576 196.302l-9.274 2.557-1.336-3.197 10.571-2.93.039 3.57Z'
        fill='#316CF4'
      />
      <path
        d='M80.491 27.902c.028.405.266.718.53.7.266-.02.457-.362.429-.767-.028-.405-.266-.719-.53-.7-.266.019-.457.362-.429.767ZM85.068 27.582c.028.406.266.718.53.7.266-.019.457-.362.429-.767-.028-.405-.266-.718-.53-.7-.265.02-.457.362-.429.767Z'
        fill='#0D1333'
      />
      <path
        d='M83.627 27.885s1.084 2.272 2.176 3.328c-.67.719-1.971.4-1.971.4l-.205-3.728Z'
        fill='#ED847E'
      />
      <path
        d='M78.966 26.521a.236.236 0 0 0 .225-.107c.58-.89 1.46-.9 1.468-.9a.239.239 0 0 0 .24-.238.235.235 0 0 0-.24-.239c-.046 0-1.147.012-1.867 1.117a.238.238 0 0 0 .174.367ZM86.92 25.87a.237.237 0 0 0 .232-.356c-.657-1.144-1.754-1.22-1.802-1.22a.24.24 0 0 0-.252.224c-.007.131.1.245.223.252.038.005.891.067 1.417.98.04.07.11.112.182.12Z'
        fill='#0D1333'
      />
      <path
        d='M73.356 205.247c.383 0 .741-.065.97-.257.18-.151.263-.363.246-.629-.013-.199-.118-.293-.204-.337-.559-.287-2.18.712-2.364.826a.12.12 0 0 0 .035.217c.35.083.852.18 1.317.18Zm.747-1.042a.35.35 0 0 1 .155.03c.032.017.07.047.076.14.012.19-.041.332-.162.433-.275.231-.932.262-1.787.091.568-.329 1.332-.694 1.718-.694Z'
        fill='#316CF4'
      />
      <path
        d='M72.067 205.07c.02 0 .039-.005.057-.014.52-.283 1.527-1.386 1.421-1.947-.02-.102-.094-.278-.38-.313a.66.66 0 0 0-.508.154c-.584.478-.704 1.93-.71 1.992a.12.12 0 0 0 .12.128Zm1.016-2.041c.018 0 .036.002.054.004.155.019.168.09.174.12.063.331-.579 1.165-1.097 1.558.06-.425.22-1.271.594-1.577a.424.424 0 0 1 .275-.105ZM112.842 203.474c.007.001.014.002.021.001.825-.059 2.268-.253 2.669-.87a.669.669 0 0 0 .062-.618.378.378 0 0 0-.274-.253c-.674-.158-2.357 1.36-2.546 1.535a.12.12 0 0 0-.029.135c.017.04.054.066.097.07Zm2.387-1.514a.347.347 0 0 1 .034.005c.053.013.085.044.106.103a.433.433 0 0 1-.037.408c-.225.346-1.011.613-2.131.73.676-.585 1.636-1.289 2.028-1.246Z'
        fill='#316CF4'
      />
      <path
        d='M112.842 203.474a.113.113 0 0 0 .089-.027c.513-.424 1.384-1.793 1.144-2.317-.056-.123-.194-.258-.517-.204a.875.875 0 0 0-.583.373c-.477.677-.247 2.02-.237 2.077a.118.118 0 0 0 .076.091.077.077 0 0 0 .028.007Zm.893-2.319c.093.01.114.056.122.075.144.314-.417 1.356-.915 1.88-.043-.399-.086-1.228.227-1.673a.633.633 0 0 1 .566-.282Z'
        fill='#316CF4'
      />
      <path
        d='M64.432 89.14c-.091-1.117-.835-1.984-1.794-2.093l-14.977-1.69c-1.137-.128-2.18.845-2.33 2.174l-4.39 38.9c-.149 1.328.65 2.509 1.787 2.638l47.528 5.363c1.136.128 2.179-.845 2.329-2.174l3.687-32.674c.15-1.329-.65-2.51-1.786-2.638l-25.863-2.919c-2.238-.252-3.976-2.279-4.19-4.887Z'
        fill='#0D1333'
      />
      <path
        d='M70.755 97.669c.077-.975-.548-1.743-1.506-1.851l-14.978-1.69c-1.136-.128-2.345.705-2.7 1.862l-9.473 30.84c-.355 1.157.278 2.199 1.414 2.327l47.528 5.363c1.136.128 2.345-.705 2.7-1.862l7.809-25.422c.355-1.156-.278-2.198-1.415-2.326l-25.862-2.919c-2.238-.252-3.697-2.045-3.517-4.322Z'
        fill='#316CF4'
      />
      <path
        d='m69.95 54.61-1.413 2.017a135.378 135.378 0 0 0-4.088 6.364 91.825 91.825 0 0 0-2.412 4.348c-.72 1.466-1.408 2.934-1.957 4.404l-.05.127-.017.054a.962.962 0 0 1-.045.108c-.022.117-.056.216-.08.352-.048.272-.082.59-.11.934-.05.69-.042 1.465.003 2.257.093 1.587.27 3.26.517 4.934.485 3.351 1.113 6.797 1.763 10.18l-3.586 1.192a74.341 74.341 0 0 1-3.796-10.15c-.493-1.76-.96-3.546-1.26-5.451a24.503 24.503 0 0 1-.313-3.002c-.021-.535-.01-1.095.038-1.696.026-.3.078-.632.125-.95l.12-.53.063-.264.055-.185c1.062-3.75 2.617-7.153 4.37-10.395a73.692 73.692 0 0 1 4.345-7.005 46.076 46.076 0 0 1 1.66-2.265l6.068 4.621Z'
        fill='#FFC3BD'
      />
      <path
        d='m56.67 59.13-1.618 2.257 8.605 7.698 1.938-3.591-8.925-6.365Z'
        fill='#0D1333'
      />
      <path
        d='M64.527 47.233c-4.717.951-8.854 12.488-8.854 12.488l9.844 8.018s3.225-5.864 5.806-11.522c2.81-6.163-1.082-10.137-6.796-8.984Z'
        fill='#0D1333'
      />
      <path
        opacity='.5'
        d='M64.527 47.233c-4.717.951-8.854 12.488-8.854 12.488l9.844 8.018s3.225-5.864 5.806-11.522c2.81-6.163-1.082-10.137-6.796-8.984Z'
        fill='#316CF4'
      />
      <path
        d='m61.53 89.702 3.395 3.818-6.148 1.88s-2.169-3.892-.236-5.272l2.989-.426Z'
        fill='#FFC3BD'
      />
      <path
        d='m65.216 97.713-5.153 1.316-1.286-3.63 6.148-1.88.291 4.194Z'
        fill='#FFC3BD'
      />
      <path
        d='M180.504 29.267c-.34-1.067-1.26-1.746-2.218-1.636l-14.975 1.72c-1.135.13-1.933 1.312-1.781 2.64l4.465 38.891c.152 1.33 1.197 2.3 2.333 2.17l47.518-5.455c1.136-.13 1.933-1.313 1.781-2.641l-3.75-32.667c-.153-1.33-1.198-2.3-2.334-2.17l-25.856 2.969c-2.239.257-4.388-1.327-5.183-3.82Z'
        fill='#0D1333'
      />
      <path
        d='M187.707 15.094a271.304 271.304 0 0 1 6.322 44.04 701.38 701.38 0 0 1-35.421 3.31 235.203 235.203 0 0 0-7.643-47.913 696.003 696.003 0 0 0 24.925-7.208 265.936 265.936 0 0 1 11.817 7.77Z'
        fill='#316CF4'
      />
      <path
        opacity='.7'
        d='M187.707 15.094a271.304 271.304 0 0 1 6.322 44.04 701.38 701.38 0 0 1-35.421 3.31 235.203 235.203 0 0 0-7.643-47.913 696.003 696.003 0 0 0 24.925-7.208 265.936 265.936 0 0 1 11.817 7.77Z'
        fill='#FAFAFA'
      />
      <path
        d='M185.69 22.509a697.327 697.327 0 0 1-27.768 6.367.746.746 0 0 1-.874-.593.76.76 0 0 1 .574-.897 699.334 699.334 0 0 0 27.727-6.535c.396-.101.799.189.893.646.093.456-.156.913-.552 1.012ZM186.687 27.71a699.56 699.56 0 0 1-27.886 5.84.747.747 0 0 1-.863-.612.766.766 0 0 1 .592-.888 700.578 700.578 0 0 0 27.849-6.01c.398-.095.794.203.88.664.085.46-.173.915-.572 1.006ZM187.582 32.943a699.88 699.88 0 0 1-27.994 5.313c-.402.07-.784-.217-.85-.63a.766.766 0 0 1 .608-.88 700.805 700.805 0 0 0 27.961-5.482c.4-.086.791.22.867.683.076.461-.191.913-.592.996ZM188.376 38.209a701.335 701.335 0 0 1-28.092 4.782.749.749 0 0 1-.839-.649.77.77 0 0 1 .625-.871 699.755 699.755 0 0 0 28.063-4.952c.401-.082.787.235.854.702.066.466-.209.91-.611.988ZM177.871 45.333a697.868 697.868 0 0 1-16.986 2.421c-.404.054-.775-.249-.825-.666-.05-.42.239-.807.643-.862a704.61 704.61 0 0 0 16.97-2.525c.404-.065.78.248.835.7.054.446-.233.866-.637.932ZM187.707 15.094a705.62 705.62 0 0 1-9.253 2.537c-.785-3.462-1.64-6.899-2.563-10.308a265.917 265.917 0 0 1 11.816 7.77Z'
        fill='#316CF4'
      />
      <path
        d='M188.582 36.157c-.144-.968-.925-1.575-1.883-1.465l-14.974 1.719c-1.136.13-2.128 1.215-2.213 2.421l-2.3 32.181c-.086 1.207.765 2.08 1.901 1.949l47.517-5.455c1.136-.13 2.127-1.215 2.213-2.421l1.895-26.527c.087-1.207-.764-2.08-1.9-1.948l-25.857 2.968c-2.238.257-4.063-1.162-4.399-3.422ZM152.205 61.123a854.56 854.56 0 0 1-4.915 39.569 3424.23 3424.23 0 0 0-35.06-5.368 818.55 818.55 0 0 0 5.608-47.542c8.6.776 17.2 1.584 25.798 2.425a790.008 790.008 0 0 1 8.569 10.916Z'
        fill='#316CF4'
      />
      <path
        opacity='.7'
        d='M152.205 61.123a854.56 854.56 0 0 1-4.915 39.569 3424.23 3424.23 0 0 0-35.06-5.368 818.55 818.55 0 0 0 5.608-47.542c8.6.776 17.2 1.584 25.798 2.425a790.008 790.008 0 0 1 8.569 10.916Z'
        fill='#FAFAFA'
      />
      <path
        d='M148.078 66.743a3455.53 3455.53 0 0 0-28.242-3.216.749.749 0 0 1 .158-1.486 3441.186 3441.186 0 0 1 28.249 3.165c.405.045.699.431.654.855-.046.423-.414.728-.819.682ZM147.549 71.534a3431.051 3431.051 0 0 0-28.225-3.37.748.748 0 0 1-.652-.827.745.745 0 0 1 .819-.658A3451.403 3451.403 0 0 1 147.721 70c.405.05.697.435.65.857-.047.426-.418.73-.822.677ZM146.992 76.32a3447.655 3447.655 0 0 0-28.205-3.527.745.745 0 0 1 .174-1.482c9.406 1.12 18.811 2.278 28.212 3.477.404.05.694.438.644.86-.049.42-.421.724-.825.672ZM146.408 81.1a3421.41 3421.41 0 0 0-28.185-3.682.748.748 0 0 1-.643-.832.743.743 0 0 1 .826-.648c9.4 1.17 18.797 2.382 28.191 3.632.404.054.692.444.64.863a.749.749 0 0 1-.829.666ZM134.604 84.318a3479.854 3479.854 0 0 0-16.969-2.282.746.746 0 0 1 .192-1.479c5.658.737 11.316 1.488 16.973 2.254a.76.76 0 0 1 .637.854.749.749 0 0 1-.833.653ZM152.205 61.123c-3.167-.354-6.335-.705-9.502-1.051a846.2 846.2 0 0 0 .933-9.866 794.304 794.304 0 0 1 8.569 10.917Z'
        fill='#316CF4'
      />
    </svg>
  );
}
